export class ConsolidationRuleDTO{
    public id!: number;
    public inputFieldIndex!: number;
    public inputFieldName!: string;
    public consolidationParameter!: string;
    public consolidationRuleDefinitionId!: number;
}